import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class TemplateService {

	public constructor(private http: HttpClient) {
	}

	public create(name: string, content: string, groupId: string): Observable<any> {
		return this.http.post(`/backoffice/templates`, {name, content, groupId});
	}

	public get(name: string): Observable<any> {
		return this.http.get(`/backoffice/templates/${name}`);
	}

	public getAll(groupId?: string): Observable<any> {
		const groupIdFilter = groupId ? '?groupId=' + groupId : '';
		return this.http.get(`/backoffice/templates${groupIdFilter}`);
	}

	public delete(name: string): Observable<any> {
		return this.http.get(`/backoffice/templates/${name}`);
	}

	public exportUrl(name: string): string {
		return `/backoffice/templates/${name}/export`;
	}

	public importUrl(): string {
		return `/backoffice/templates/import`;
	}
}
